exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-5d449538]{padding:15px;border-radius:4px;background-color:#ff6665;font-weight:400;font-size:14px!important;line-height:19px!important;letter-spacing:.02em;color:#000;color:#fff;width:-moz-fit-content;width:fit-content;position:absolute;right:0;z-index:100;top:45px;bottom:auto!important}.error[data-v-5d449538]:before{content:\"\";position:absolute;right:9px;top:-3px;width:.7em;height:.7em;background:linear-gradient(to bottom left,#ff6665 50%,transparent 0);border-radius:.2em;transform:rotate(-45deg)}", ""]);

// exports
